<form>
  <mat-form-field>
    <mat-label>Search</mat-label>
    <mat-icon matIconPrefix>search</mat-icon>
    <input matInput #searchInput placeholder="Order or BoL#" title="Search for Order or BoL#" />
    @if (searchInput.value) {
      <button matIconSuffix mat-icon-button aria-label="Clear search term" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Order Status</mat-label>
    <mat-select [(ngModel)]="filters.tripStatus" name="tripStatus" multiple (closed)="emitChange()">
      <mat-option value="Scheduled">Available</mat-option>
      <mat-option value="InTransit">In Transit</mat-option>
      <mat-option value="Delivered">Delivered</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Pick-up between</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input
        matStartDate
        name="pickupStartDate"
        [ngModel]="filters.pickupStartDate"
        (dateChange)="onDateChange('start', $event)"
      />
      <input
        matEndDate
        name="pickupEndDate"
        [ngModel]="filters.pickupEndDate"
        (dateChange)="onDateChange('end', $event)"
      />
    </mat-date-range-input>
    @if (filters.pickupStartDate && filters.pickupEndDate) {
      <button matIconSuffix mat-icon-button aria-label="Clear date range" (click)="clearPickupDates(); picker.open()">
        <mat-icon>close</mat-icon>
      </button>
    } @else {
      <mat-datepicker-toggle matIconSuffix [for]="picker" />
    }
    <mat-date-range-picker #picker (closed)="emitChange()" />
  </mat-form-field>
  <button
    class="text-nowrap"
    mat-flat-button
    type="button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleOverlay()"
  >
    <mat-icon>filter_alt</mat-icon>
    Filters
    @if (hiddenFilterCount > 0) {
      <span class="filter-count">{{ hiddenFilterCount }}</span>
    }
  </button>
</form>
<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="overlayOpen"
  [cdkConnectedOverlayDisableClose]="true"
  (backdropClick)="emitChange()"
>
  <div class="filter-overlay-container">
    <div class="d-flex flex-column filters rounded p-3 mat-elevation-z6">
      <mat-form-field>
        <mat-label>Arrival Status</mat-label>
        <mat-select [(ngModel)]="filters.arrivalStatus" name="arrivalStatus" multiple>
          <mat-option value="ONTIME">On Time</mat-option>
          <mat-option value="ATRISK">At Risk</mat-option>
          <mat-option value="LATE">Late</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Planning Status</mat-label>
        <mat-select [(ngModel)]="filters.isAssigned" name="plannedStatus" multiple>
          <mat-option [value]="true">Assigned</mat-option>
          <mat-option [value]="false">Unassigned</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Temp Range</mat-label>
        <mat-select [(ngModel)]="filters.tempRange" name="tempRange" multiple>
          <mat-option value="InRange">In Range</mat-option>
          <mat-option value="OutOfRange">Out of Range</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Fleet Code</mat-label>
        <mat-select [(ngModel)]="filters.fleetIds" name="fleetId" multiple>
          @for (fleetId of fleetOptions; track fleetId) {
            <mat-option [value]="fleetId">{{ fleetId }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (customerOptions.length > 1) {
        <mat-form-field>
          <mat-label>Customer</mat-label>
          <mat-select [(ngModel)]="filters.customerIds" name="customerId" multiple>
            @for (customer of customerOptions; track customer.customerId) {
              <mat-option [value]="customer.customerId">
                {{ customer.customerName }}
                <span class="mat-body-small">{{ customer.customerId }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <button matButton="text" type="button" (click)="resetForm()">Clear all filters</button>
    </div>
  </div>
</ng-template>
